import { SaveRecordAction } from '@aibees/elephant/hooks';
import { useEnrichPersonSaveRecord } from '@aibees/elephant/hooks/people/use-enrich-person-save-record';
import { useSaveRecordEnrichableCount } from '@aibees/elephant/hooks/people/use-save-record-enrichable-count';
import { CreditUsageType } from '@aibees/shared/definition';
import { useCreditUsageItem } from '@aibees/shared/hooks';
import { classnames } from '@aibees/shared/utils';
import { Typography } from '@mui/material';
import { memo } from 'react';
import { InfoItem } from '../enrich-dialog';
import * as Styled from './styles';
import * as SX from './sx';
import type { EnrichEmailDialogProps as Props } from './types';

export const EnrichEmailDialog = memo(
  ({ className, onClose, open, table }: Props) => {
    const { enrichable, isLoading: countLoading } =
      useSaveRecordEnrichableCount(
        SaveRecordAction.CONTACT_ENRICH_EMAIL,
        open ? table : undefined
      );

    const { credit } = useCreditUsageItem(
      CreditUsageType.CONTACT_EMAIL_FINDING
    );
    const { credit: jobChangeCredit } = useCreditUsageItem(
      CreditUsageType.CONTACT_JOB_CHANGE
    );

    const { handleEnrich, isLoading } = useEnrichPersonSaveRecord(
      SaveRecordAction.CONTACT_ENRICH_EMAIL,
      onClose,
      table,
      enrichable
    );

    const informations: InfoItem[] = [
      {
        count: enrichable,
        label: 'records need enrichment.',
        helperText:
          'These records are emails with the status “Update, Re-verified, Invalid or Not Found” and they need to be enriched again.',
      },
    ];

    return (
      <Styled.Wrapper
        className={classnames('EnrichEmailDialog', className)}
        sx={SX.root}
        open={open}
        onClose={onClose}
        icon="email-outline"
        title="Enrich Emails"
        informations={informations}
        cost={credit}
        onSubmit={handleEnrich}
        enrichLoading={isLoading}
        countLoading={countLoading}
        disableEnrich={!enrichable || enrichable === 0}
        unEnrichableHelperText="The selected contacts emails are already enriched and don’t need enrichment."
        recordsCount={table?.selection.included.length || 0}
        description={
          <Typography variant="body3" color="grey.700" fontWeight={400}>
            Any record with a job change will first run a Job-Change Update,
            which costs {jobChangeCredit}x credits.
          </Typography>
        }
        costText="valid email found"
      />
    );
  }
);

EnrichEmailDialog.displayName = 'EnrichEmailDialog';
